export const USER_SETTINGS_KEY = "ksprUserSettings";

export const createNewLsUserSettings = ({ currentSettings, pageName, key, value }) => {
	return {
		...(currentSettings ? currentSettings : {}),
		[pageName]: {
			...(currentSettings?.[pageName] ? currentSettings[pageName] : {}),
			[key]: value,
		},
	};
};
